export const initialFilterState = {
    imei: {
        label: "IMEI",
        value: "",
    },
    model: {
        label: "Modello",
        value: "",
    },
    assistenza: {
        label: "Assistenza",
        value: "",
    },
    statoRestituzione: {
        label: "Stato restituzione",
        value: "",
    },
    tags: {
        label: 'Tag',
        value: []
    },
    collaborators: {
        label: 'Collaboratore',
        value: []
    },
    prodotto: {
        label: "Prodotto",
        value: "",
    },
    descrizione: {
        label: "Descrizione",
        value: "",
    },
    contratto: {
        label: "Contratto",
        value: "",
    },
    idSpedizione: {
        label: "ID spedizione",
        value: "",
    },
    tipologiaDiVendita: {
        label: "Tipologia di vendita",
        value: "",
    },
    dataTermineAssistenza: {
        name: "Data termine assistenza:",
        from: "",
    },
    interventiInAssistenza: {
        label: "Interventi in assistenza",
        value: "",
    },
    dataConsegna: {
        name: "Data consegna:",
        from: null,
        to: null
    }
}
